import { render, staticRenderFns } from "./CollectionSlotOrdersList.vue?vue&type=template&id=083e86f6&scoped=true&"
import script from "./CollectionSlotOrdersList.vue?vue&type=script&lang=ts&"
export * from "./CollectionSlotOrdersList.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionSlotOrdersList.vue?vue&type=style&index=0&id=083e86f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e86f6",
  null
  
)

export default component.exports